<template>
  <v-container
    fluid
    grid-list-xl
  >
    <v-card
      flat
      class="groups"
    >
      <v-card-text class="groups-header">
        Editar: Rateio {{ item.name }}
      </v-card-text>
      <div
        class="group-item"
      >
        <div class="config">
          <p>Tipo de rateio: <span>*</span></p>
          <AppRadioBox
            v-model="group.apportionmentType"
            :options="apportionmentTypeOptions"
            row
          />
        </div>
        <div class="config">
          <p>Visível para o vendedor: <span>*</span></p>
          <AppRadioBox
            v-model="group.visibleToSeller"
            :options="visibleToSellerOptions"
            row
          />
        </div>
        <div class="config">
          <p>Acelerador: <span>*</span></p>
          <AppRadioBox
            v-model="group.acceleratorType"
            :options="acceleratorTypeOptions"
            row
          />
        </div>
        <div class="config">
          <AppSelectGroup
            v-model="group.partnerIds"
            :items="partners"
            :customFilter="customFilter"
            :disabled="group.allPartners"
            :v="$v.group.partnerIds"
            @blur="$v.group.partnerIds.$touch"
            label="Selecione parceiros"
            placeholder="Selecione os parceiros"
            on-text="name"
            on-value="_id"
            clearable
            multiple
          />
          <AppSwitch
            @change="includeAllPartnersIds"
            label="Selecionar todos"
          />
        </div>
        <ResponsiblesConfig
          @groupOptions="getGroupOptions"
          @isInvalidForm="getIsInvalidForm"
          :group="group"
          type="edit"
        />
      </div>
    </v-card>
    <v-card
      flat
      class="mt-1"
    >
      <div class="btn-footer">
        <v-btn
          @click="cancel"
          color="secondary"
        >
          Cancelar
        </v-btn>
        <v-btn
          @click="save()"
          :disabled="disabledSaveBtn"
          color="primary"
        >
          Salvar
        </v-btn>
      </div>
    </v-card>
  </v-container>
</template>

<script>
  import AppRadioBox from '@/components/ui/inputs/AppRadioBox'
import AppSelectGroup from '@/components/ui/inputs/AppSelectGroup'
import AppSwitch from '@/components/ui/inputs/AppSwitch'
import { updateCampaignApportionmentGroup } from '@/services/containers/partners/campaigns'
import { required } from 'vuelidate/lib/validators'
import ResponsiblesConfig from './responsibles-config/ResponsiblesConfig.vue'
import { FEATURE_FLAGS } from '@/helpers/featureFlags'


  export default {
    name: 'EditGroup',

    components: {
      AppRadioBox,
      AppSelectGroup,
      AppSwitch,
      ResponsiblesConfig,
    },

    props: {
      partners: {
        type: Array,
        default: () => ([])
      },
      item: {
        type: Object,
        default: () => ({})
      }
    },

    data: () => ({
      group: {},
      IsInvalidForm: false
    }),

    created() {
      this.group = this.item
    },

    computed: {
      isRebateByRoleEnabled() {
        return this.$isFeatureFlagActive(FEATURE_FLAGS.rebateByRole)
      },
      apportionmentTypeOptions() {
        return [
          {
            title: 'Filial',
            value: 'filial'
          },
          ...(this.isRebateByRoleEnabled ? [
            {
              title: 'Função',
              value: 'role'
            },
            {
              title: 'Ambos',
              value: 'any'
            }
          ]  : [])
        ]
      },
      visibleToSellerOptions() {
        return [
          {
            title: 'Sim',
            value: true
          },
          {
            title: 'Não',
            value: false
          }
        ]
      },
      acceleratorTypeOptions() {
        return [
          {
            title: 'Participante',
            value: 'participant'
          },
          // {
          //   title: 'Vendedor',
          //   value: 'seller'
          // }
        ]
      },
      disabledSaveBtn() {
        const isEmptyGroup = this.group.ownerProportion === 0 || this.group.ownerProportion > 100
        const isEmptyPartners = this.group?.partnerIds?.length < 1
        return isEmptyGroup || isEmptyPartners || this.IsInvalidForm
      }
    },

    methods: {
      cancel() {
        this.$emit('reload')
      },
      includeAllPartnersIds() {
        this.group.partnerIds = this.partners.map(partner => partner._id)
        this.group.allPartners = !this.group.allPartners
      },
      async save() {
        const payload = {
          acceleratorType: this.group.acceleratorType,
          apportionmentType: this.group.apportionmentType,
          ownerProportion: this.group.ownerProportion,
          partnerIds: this.group.partnerIds,
          rules: this.group.rules,
          visibleToSeller: this.group.visibleToSeller
        }
        this.$showLoading()
        try {
          this.$v.group.$touch()
          if (this.$v.group.$invalid) return
          const res = await updateCampaignApportionmentGroup(this.item._id, payload)
          this.$toast(res.data.message || 'Grupo editado com sucesso!', 'green')
          this.$emit('reload')
        } catch (err) {
          this.$toast(err.response.data.message, 'red')
        } finally {
          this.$hideLoading()
        }
      },
      customFilter (item, queryText) {
        const { name = '', ein = ''} = item
        const searchText = queryText?.toLowerCase()

        return name?.toLowerCase()?.indexOf(searchText) > -1 || ein?.indexOf(searchText) > -1
      },
      getGroupOptions(payload) {
        this.group.rules = payload.rules
        this.group.ownerProportion = payload.ownerProportion
      },
      getIsInvalidForm(value) {
        this.IsInvalidForm = value
      }
    },

    validations() {
      return {
        group: {
          partnerIds: {
            required,
          }
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .groups {
    padding: 24px;
    .groups-header {
      border-bottom: 1px solid var(--neutral-low-medium);
      padding: 15px 0;
    }
    .group-item {
      border-bottom: 1px solid var(--neutral-low-medium);
      padding: 24px 0;
      &:last-of-type {
        border-bottom: none;
      }
      .config {
        p {
          font-size: 16px;
          font-weight: 700;

          span {
            color: var(--negative-light)
          }
        }
      }
    }
    .v-btn {
      margin-left: 0.1rem;
      .v-btn__content {
        span {
          margin-top: 1px;
        }
      }
    }
    &-header {
      font-size: 20px;
      font-weight: 500;
      color: var(--neutral-low-dark)
    }
  }
  .btn-footer {
    display: flex;
    justify-content: flex-end;
  }
</style>
